import {TemplateTranslationDTO} from "../../model/template-translation.model";
import {TemplateCodeTypes} from "../../enum/template-code.enum";
import {TrackableEntity, trackableType} from "../../model/trackable-entity.model";
import {langTypes} from "../../types/lang.type";

export class TemplateDTO extends TrackableEntity {
  code: TemplateCodeTypes;
  imageUrl: string;
  link: string;
  startDate: string;
  createdDate: string;
  endDate: string;
  body: TemplateTranslationDTO[];
  override type?: trackableType = 'TEMPLATE';

  constructor(data?) {
    super();
    Object.assign(this, data);
  }

  getAttributeValue(key: string, lang: langTypes): string {
    const translation = this.body?.find(t => t.languageCode === lang);
    const attribute = translation?.attributes?.find(a => a.key === key);
    return attribute?.value;
  }

}

